export default __webpack_public_path__ + "static/media/news-btn.54103313.jpg";